(function () {

    angular.module('tmx-app')
        .controller('deviceManagementEditCtrl', ['$scope', 'tmxUtility', 'resolvedData','TMX_FINANCE_CONSTANTS' ,
            'lookupService', '$state','ToastService','$location','$anchorScroll', 
            function DeviceManagementEditCtrl($scope, tmxUtility , resolvedData, TMX_FINANCE_CONSTANTS, lookupService, $state,
                ToastService,$location,$anchorScroll) {
                var checkEndDate;
        //Functions/Method
                var devicemanagementVM=this;
        
                devicemanagementVM.dataLoading=false;
                checkEndDate = tmxUtility.checkEndDate;
                devicemanagementVM.formSubmitted = false;
                devicemanagementVM.error_msg = "";
                devicemanagementVM.date = new Date().toJSON();
                devicemanagementVM.showStatus = false;
                devicemanagementVM.readonly = false;
                devicemanagementVM.isEdit = false;
                devicemanagementVM.endmindate = angular.copy(devicemanagementVM.date);
                devicemanagementVM.dirtyFormControls = [];
                devicemanagementVM.StartDateInvalid = false;
                devicemanagementVM.EndDateInvalid = false;
//////////////////////////DATE TIME PICKER CONFIGURATIONS/////////////////////
                devicemanagementVM.currentdateObj = new Date();
                devicemanagementVM.date = devicemanagementVM.currentdateObj.toJSON();

        //devicemanagementVM.minEnddate = angular.copy(devicemanagementVM.date);
                devicemanagementVM.StartDateReadonly = devicemanagementVM.edit;
                devicemanagementVM.EndDateReadonly = false;

                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;

                lookupService.getLookupByType(lkupType.YES_NO).then(function (response) {
            
                    angular.forEach(response,function(type){
                        type.LookupId = parseInt(type.HiddenValue);
                    });

                    devicemanagementVM.yesNoLkp = response;
                });


                lookupService.getLookupByType(lkupType.TRUE_FALSE_BIT).then(function (response) {
            
                    angular.forEach(response,function(type){
                        type.LookupId = (/true/i).test(type.HiddenValue);
                    });

                    devicemanagementVM.TrueFalseBitLkp = response;
                });


                lookupService.getLookupByType(lkupType.TRUE_FALSE).then(function (response) {            
                    angular.forEach(response,function(item){
                        item.LookupId = item.VisibleValue;
                    });
            

                    devicemanagementVM.trueFalseLkp = response;
                });

                $scope.populateEndDate = function(){
                    var EndDate ;
                    if(devicemanagementVM.vm.EffectiveEndDate) {
                        EndDate = new Date(devicemanagementVM.vm.EffectiveEndDate);//forming a date object from JSON string
                    }
                    else {
                        EndDate = new Date();
                    }
                    return EndDate;
                };

                if($state.data.info==true) {
                    devicemanagementVM.readonly = true;
                    devicemanagementVM.StartDateReadonly = true;
                    devicemanagementVM.EndDateReadonly = true;

                }
                if(angular.isDefined(resolvedData.Device.data)) {
                    devicemanagementVM.vm = resolvedData.Device.data;            
                    devicemanagementVM.minEndDate = devicemanagementVM.vm.EffectiveStartDate;
                    devicemanagementVM.vm = resolvedData.Device.data;
                    devicemanagementVM.isEdit = true;
                    if($state.data.info!=true){
                // devicemanagementVM.StartDateReadonly = false;
                    }
                }
                else {
                    devicemanagementVM.vm = resolvedData.Device;
                    devicemanagementVM.vm.TmxDeviceDetail= [{}];
                    devicemanagementVM.vm.TmxUserDevice= [{}];
            
                    devicemanagementVM.vm.EffectiveStartDate = devicemanagementVM.date;
            //define minimum emd date
                    devicemanagementVM.minEndDate = devicemanagementVM.vm.EffectiveStartDate;

                    devicemanagementVM.StartDateReadonly = false;
            // making effective end date to NOT display DEFAULT value
                    devicemanagementVM.vm.EffectiveEndDate =  new Date(undefined);
                }

                if(devicemanagementVM.vm.EffectiveEndDate < devicemanagementVM.date) {
                    devicemanagementVM.vm.status = "inactive";
                }
                else if(angular.isDefined(devicemanagementVM.vm.TmxUserDevice)) {
                    devicemanagementVM.vm.status = "active";
                }
                devicemanagementVM.users = resolvedData.Users.data;
                lookupService.getCompanyTypes().then(function (types){
                    devicemanagementVM.lookup = types;
                });
                devicemanagementVM.status = [
                    { HiddenValue: "active",
                        VisibleValue: "Active"
                    },
                    { HiddenValue: "inactive",
                        VisibleValue: "Inactive"
                    },
                    { HiddenValue: "pending",
                        VisibleValue: "Pending"
                    }
                ];

////////////////////////////////DATE START VALIDATION//////////////////////////////////////////////////////////////////
                devicemanagementVM.onStartDateSelected = function(selectedDate) {
                    if(selectedDate!=null) {
                        devicemanagementVM.vm.EffectiveStartDate = selectedDate.toJSON();//start Date
                        devicemanagementVM.StartDateInvalid = false;
                        devicemanagementVM.minEndDate = devicemanagementVM.vm.EffectiveStartDate;//ensuring that end date >= start Date

                //calling validation function passing in strings
                        if(checkEndDate(devicemanagementVM.vm.EffectiveStartDate,devicemanagementVM.vm.EffectiveEndDate)) {
                            devicemanagementVM.onEndDateSelected(null);
                            devicemanagementVM.dialogForm.EffectiveEndDate.$invalid = true;
                            devicemanagementVM.dialogForm.EffectiveEndDate.$viewValue = "Invalid Date";
                        }

                    }
                    else{
                        devicemanagementVM.StartDateInvalid = true;
                    }
                    var st = devicemanagementVM.getStatus();
                    devicemanagementVM.currentStatus = st;
                };
        ////////////////////////////////DATE START VALIDATION//////////////////////////////////////////////////////////////////
        // $scope.checkEndDate = function(){

        //     if(angular.isDefined(devicemanagementVM.vm)){


        //         var StartDate = new Date(devicemanagementVM.vm.EffectiveStartDate);//forming a date object from JSON string
        //         var StartDateString = StartDate.toDateString();//getting the date out of the whole date-time
        //         var StartDateNew = new Date(StartDateString);//converting the new string to date object

        //         var EndDate = new Date(devicemanagementVM.vm.EffectiveEndDate);
        //         var EndDateString = EndDate.toDateString();
        //         var EndDateNew = new Date(EndDateString);//converting the new string to date object


        //         if(devicemanagementVM.vm.EffectiveEndDate == undefined ||
        //             devicemanagementVM.vm.EffectiveEndDate == null ||
        //             StartDateNew > EndDateNew){
        //             //if start date is greater than end date -> make end date field in form invalid
                    
        //             return true;
        //         }
        //         else{
        //             return false;
        //         }
        //     }
        // };
////////////////////////////////DATE START VALIDATION//////////////////////////////////////////////////////////////////
                devicemanagementVM.onEndDateSelected = function(selectedDate) {
                    if(selectedDate != null ) {

                        devicemanagementVM.vm.EffectiveEndDate = selectedDate.toJSON();//end Date
                        devicemanagementVM.EndDateInvalid = false;
                    }
                    else{
                        devicemanagementVM.EndDateInvalid = true;
                        devicemanagementVM.vm.EffectiveEndDate = undefined;
                    }
            //var st = devicemanagementVM.getStatus();
            //devicemanagementVM.currentStatus = st;
                };
////////////////////////////////  STATUS ////////////////////////////////////////////////////////////////////
//        devicemanagementVM.getStatus = function()
//        {
//            if(angular.isDefined(devicemanagementVM.vm.EffectiveEndDate) &&
//                angular.isDefined(devicemanagementVM.vm.EffectiveStartDate))
//            {
//                if( devicemanagementVM.vm.EffectiveEndDate!=null &&
//                    devicemanagementVM.vm.EffectiveEndDate!="Invalid Date" &&
//                    devicemanagementVM.vm.EffectiveStartDate!=null)
//                {
//
//
//                    if(angular.isObject(devicemanagementVM.vm.EffectiveEndDate))
//                    {
//
//                        devicemanagementVM.vm.EffectiveEndDate = devicemanagementVM.vm.EffectiveEndDate.toJSON();
//                    }
//
//
//                    var startDate = devicemanagementVM.vm.EffectiveStartDate;
//                    var endDate = devicemanagementVM.vm.EffectiveEndDate;
//                    var date = devicemanagementVM.date.split("T");
//                    date = date[0];
//
//                    if(devicemanagementVM.vm.EffectiveEndDate!="Invalid Date" && devicemanagementVM.vm.EffectiveEndDate!=null){
//                        endDate = devicemanagementVM.vm.EffectiveEndDate.split("T");
//                        endDate = endDate[0];
//                    }
//                    if(angular.isObject(devicemanagementVM.vm.EffectiveStartDate))
//                    {
//                        devicemanagementVM.vm.EffectiveStartDate = devicemanagementVM.vm.EffectiveStartDate.toJSON();
//                        startDate = devicemanagementVM.vm.EffectiveStartDate.split("T")
//                        startDate = startDate[0];
//                    }
//                    else
//                    {
//                        startDate = devicemanagementVM.vm.EffectiveStartDate.split("T")
//                        startDate = startDate[0];
//                    }
//                    if(endDate>=date && startDate<=date)
//                    {
//                        if(angular.isDefined(devicemanagementVM.vm.TmxUserDevice))
//                        {
//                            if(angular.isDefined(devicemanagementVM.vm.TmxUserDevice[0]) && devicemanagementVM.vm.TmxUserDevice[0].UserId!=null)
//                            {
//                                return "Active";
//                            }
//                        }
//                        return "Pending";
//                    }
//                    else if(startDate>=date)
//                    {
//                        return "Pending";
//                    }
//                }
//                if(devicemanagementVM.vm.EffectiveEndDate=="Invalid Date")
//                {
//                    return "Pending";
//                }
//                if(devicemanagementVM.vm.EffectiveEndDate<devicemanagementVM.date)
//                {
//                    return "Inactive";
//                }
//
//            }
//            return "Inactive";
//
//        }

                devicemanagementVM.getUser = function() {
                    if(angular.isDefined(devicemanagementVM.vm.TmxUserDevice)) {
                        if(angular.isDefined(devicemanagementVM.vm.TmxUserDevice[0])) {
                            return devicemanagementVM.vm.TmxUserDevice[0].UserId;
                        }
                    }
                    return undefined;
                }


                $scope.$watch(devicemanagementVM.getUser,devicemanagementVM.userChanged);
                devicemanagementVM.getDateErrors = function(){
                    return devicemanagementVM.vm.EffectiveEndDate;
                };
                devicemanagementVM.getFormErrors = function() {
                    if(angular.isDefined(devicemanagementVM.dialogForm)) {
                        if(devicemanagementVM.dialogForm.$invalid || devicemanagementVM.vm.EffectiveEndDate=="Invalid Date") {
                            return devicemanagementVM.dialogForm.$error;
                        }
                    }
                    return undefined;
                }

                devicemanagementVM.errorChanged = function(newErrors,oldErrors) {
                    var errorFormLength = 0;
                    devicemanagementVM.error_msg = '' ;
                    if(newErrors!=oldErrors || !angular.isDefined(devicemanagementVM.vm.EffectiveEndDate) ||
                devicemanagementVM.vm.EffectiveEndDate=="Invalid Date" || devicemanagementVM.vm.EffectiveEndDate==null) {
                        devicemanagementVM.dirtyFormControls = [];
                        angular.forEach(devicemanagementVM.dialogForm, function(value, key) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)
                        || (typeof value === 'object' && value.$viewValue=="Invalid Date")) {
                                errorFormLength++;
                                if(key=="PhoneNumber"){
                                    var name = value.$name;
                                    name = name.replace(/([A-Z])/g, ' $1').trim();
                                    value.$name=name;
                                }
                       

                                devicemanagementVM.dirtyFormControls.push(value.$name);


                            }
                        });

                        if(errorFormLength) {
                            devicemanagementVM.error_msg = "Required field(s): " ;
                            for (var i = 0; i < errorFormLength ; i++) {
                                if(i==errorFormLength-1) {
                                    devicemanagementVM.error_msg +=  devicemanagementVM.dirtyFormControls[i];
                                }
                                else {
                                    devicemanagementVM.error_msg +=  devicemanagementVM.dirtyFormControls[i] + ", ";
                                }
                            }
                        }
                        else {
                            devicemanagementVM.formInvalid = false;
                        }
                    }
                }
                $scope.$watch(devicemanagementVM.getFormErrors,devicemanagementVM.errorChanged,true);
                $scope.$watch(devicemanagementVM.getDateErrors,devicemanagementVM.errorChanged,true);
/////////////////////////////////////////////POPULATE END DATE///////////////////////////////////////////////////////

                devicemanagementVM.save = function(action,form){
                    devicemanagementVM.formSubmitted = true;
                    if (form.$invalid || devicemanagementVM.vm.EffectiveEndDate=="Invalid Date" || devicemanagementVM.vm.EffectiveEndDate==null) {
                        devicemanagementVM.formInvalid = true;
                        devicemanagementVM.dirtyFormControls = [];
                        angular.forEach(form, function(value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)
                        || (typeof value === 'object' && value.$viewValue=="Invalid Date")
                            ) {
                                value.$setTouched();
                                devicemanagementVM.dirtyFormControls.push(value.$name);
                            }
                        });
                        devicemanagementVM.error_msg = "Required field(s): ";
                        for (var i = 0; i < devicemanagementVM.dirtyFormControls.length; i++) {
                            if(i==devicemanagementVM.dirtyFormControls.length-1) {
                                devicemanagementVM.error_msg +=  devicemanagementVM.dirtyFormControls[i];
                            }
                            else {
                                devicemanagementVM.error_msg +=  devicemanagementVM.dirtyFormControls[i] + ", ";
                            }
                        }
                        $location.hash('error');
                        $anchorScroll.yOffset = 600;
                // call $anchorScroll()
                        $anchorScroll();
                    }
                    else{
                        devicemanagementVM.dataLoading=true;
                        devicemanagementVM.formInvalid = false;
                        var startDate = tmxUtility.setStartDate(devicemanagementVM.vm.EffectiveStartDate);
                /* splitting the time in case of effective end date as adding constant of 23 hours
                adds up and take it to next day date*/
                        var endDate = tmxUtility.setEndDate(devicemanagementVM.vm.EffectiveEndDate);
                        devicemanagementVM.vm.EffectiveStartDate = startDate.toJSON();//JSON date sen to backend
                        devicemanagementVM.vm.EffectiveEndDate = endDate.toJSON();//JSON date sen to backend
                        if(angular.isDefined(devicemanagementVM.vm.TmxUserDevice)) {
                            if(angular.isDefined(devicemanagementVM.vm.TmxUserDevice[0])) {
                                if(angular.isDefined(devicemanagementVM.vm.TmxUserDevice[0].UserId) && devicemanagementVM.vm.TmxUserDevice[0].UserId!=null) {
                                    devicemanagementVM.vm.TmxUserDevice[0].EffectiveEndDate = devicemanagementVM.vm.EffectiveEndDate;
                                    devicemanagementVM.vm.TmxUserDevice[0].EffectiveStartDate = devicemanagementVM.vm.EffectiveStartDate;
                                    var user = [];
                                    user.push(devicemanagementVM.vm.TmxUserDevice[0]);
                                    devicemanagementVM.vm.TmxUserDevice = user;
                                }
                                else
                                    devicemanagementVM.vm.TmxUserDevice = undefined;
                            }
                            else
                                devicemanagementVM.vm.TmxUserDevice = undefined;
                        }
                        if(!devicemanagementVM.vm.TmxDeviceDetail[0].EffectiveStartDate) {
                            devicemanagementVM.vm.TmxDeviceDetail[0].EffectiveStartDate = devicemanagementVM.vm.EffectiveStartDate;
                        }
                        if(!devicemanagementVM.vm.TmxDeviceDetail[0].EffectiveEndDate) {
                            devicemanagementVM.vm.TmxDeviceDetail[0].EffectiveEndDate = devicemanagementVM.vm.EffectiveEndDate;
                        }

                        devicemanagementVM.vm.DeviceId = devicemanagementVM.vm.DeviceID;
                        devicemanagementVM.vm.DeviceStatusLkpID = parseInt(devicemanagementVM.vm.DeviceStatusLkpID);
                //devicemanagementVM.vm.ActiveFlag = parseInt(devicemanagementVM.vm.ActiveFlag);
                
                        if(devicemanagementVM.vm.TmxDeviceDetail[0]){
                    //devicemanagementVM.vm.TmxDeviceDetail[0].ExpandableStorageFlag = parseInt(devicemanagementVM.vm.TmxDeviceDetail[0].ExpandableStorageFlag);
                    //devicemanagementVM.vm.TmxDeviceDetail[0].CameraEnableFlag =  parseInt(devicemanagementVM.vm.TmxDeviceDetail[0].CameraEnableFlag);
                    //devicemanagementVM.vm.TmxDeviceDetail[0].PrintingEnableFlag =  parseInt(devicemanagementVM.vm.TmxDeviceDetail[0].PrintingEnableFlag);
                    //devicemanagementVM.vm.TmxDeviceDetail[0].NFCEnableFlag =  parseInt(devicemanagementVM.vm.TmxDeviceDetail[0].NFCEnableFlag);
                    //devicemanagementVM.vm.TmxDeviceDetail[0].BluetoothEnableFlag = parseInt(devicemanagementVM.vm.TmxDeviceDetail[0].BluetoothEnableFlag);
                            devicemanagementVM.vm.TmxDeviceDetail[0].GPSEnableFlag =  parseInt(devicemanagementVM.vm.TmxDeviceDetail[0].GPSEnableFlag);
                            devicemanagementVM.vm.TmxDeviceDetail[0].DeviceMobileInternet =  parseInt(devicemanagementVM.vm.TmxDeviceDetail[0].DeviceMobileInternet);
                    //devicemanagementVM.vm.TmxDeviceDetail[0].CDMAFlag =  parseInt(devicemanagementVM.vm.TmxDeviceDetail[0].CDMAFlag);
                    //devicemanagementVM.vm.TmxDeviceDetail[0].TabletFlag =  parseInt(devicemanagementVM.vm.TmxDeviceDetail[0].TabletFlag);
                            devicemanagementVM.vm.TmxDeviceDetail[0].ActiveFlag = devicemanagementVM.vm.ActiveFlag;                    
                        }
                

                        devicemanagementVM.vm.$saveOrUpdate().then(function(promise){
                            devicemanagementVM.dataLoading=false;
                            if(angular.isDefined($state.data.grid.deviceGrid))  $state.data.grid.deviceGrid.dataSource.read();

                            if(angular.isDefined(promise)) {
                                if(promise.status>=400) {
                                    devicemanagementVM.formSubmitted = false;
                                    var displayMsg = "";
                                    if(angular.isDefined(promise.data.ModelState)) {
                                        var models=Object.keys(promise.data.ModelState);
                                        models.forEach(function (key){displayMsg+=(promise.data.ModelState[key])})
                                    }
                                    else
                                        displayMsg = promise.data.Message;
                            // devicemanagementVM.error_msg = promise.statusText;
                                    ToastService.showCustomToast("error",displayMsg);

                                }
                                else {
                                    if(action=="save") {
                                        $state.searchClear = true;
                                        $state.go("^");
                                    }
                                    else if(action=="saveandnew") {
                                        $state.searchClear = true;
                                        $state.reload($state.current);
                                    }
                                }
                            }
                            else
                                ToastService.showCustomToast("error","Some Error Occured");
                        });
                    }
                };

                devicemanagementVM.cancel = function(){
                    $state.searchClear = true;
                    $state.go("^");
                };

        //devicemanagementVM.currentStatus = devicemanagementVM.getStatus();

            }]);
})();

